interface SetNicknameErrorProps {
  message: string
}

export function SetNicknameError(props: SetNicknameErrorProps) {
  if (!props.message) return null

  return (
    <div className='absolute bottom-[24px] left-0 w-full px-[20px]'>
      <p
        className='text-[12px] text-[#FF3B30] leading-normal m-0'
        data-testid='nickname-error'
      >
        {props.message}
      </p>
    </div>
  )
}
